import { Button, InfoLabel, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "@fluentui/react-components";
import { bundleIcon, EditFilled, EditRegular } from "@fluentui/react-icons";
import { useState } from "react";
import ChangeValueDialog from "./ChangeValueDialog";

const EditIcon = bundleIcon( EditFilled, EditRegular );

export default function HUDMainPanel_CharacterSheet() {
    const [ changeValueDialogOpen, setChangeValueDialogOpen ] = useState<boolean>( false );
    const [ changeValueName, setChangeValueName ] = useState<string>( "" );
    const [ changeValueMax, setChangeValueMax ] = useState<number>( 20 );
    const [ unusedPoints, setUnusedPoints ] = useState<number>( 20 );
    
    const changeValueOpen = ( valueName: string, valueMax: number ) => {
        setChangeValueName( valueName );
        setChangeValueMax( valueMax );
        setChangeValueDialogOpen( true );
    };

    const handleChangeValue = ( newValue: number ) => {
        
    };

    return (
        <div>
            <h4>Character Sheet</h4>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Stat</TableHeaderCell>
                        <TableHeaderCell>Value</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <TableRow>
                        <TableCell colSpan={2}>
                            <b>Unused points:</b> {unusedPoints}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <InfoLabel label="Strength" info={
                                <div>
                                    <b>Strength</b>
                                    <p>
                                        Raw physical power.
                                    </p>
                                    <p>
                                        <b>Used for:</b>
                                        <ul>
                                            <li>Melee attacks (heavy weapons)</li>
                                            <li>Lifting, pushing, breaking things</li>
                                            <li>Athletics checks (climbing, jumping, grappling)</li>
                                        </ul>
                                    </p>
                                </div>
                            } />
                        </TableCell>
                        <TableCell>
                            <span>0</span>
                            <Button appearance="transparent" size="small" style={{ marginLeft: "0.5rem" }} icon={<EditIcon />} onClick={() => changeValueOpen("Strength", 20)} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <InfoLabel label="Dexterity" info={
                                <div>
                                    <b>Dexterity</b>
                                    <p>
                                        Agility, reflexes, coordination.
                                    </p>
                                    <p>
                                        <b>Used for:</b>
                                        <ul>
                                            <li>Ranged attacks and finesse weapons</li>
                                            <li>Armour class (how hard you are to hit)</li>
                                            <li>Stealth, acrobatics, sleight of hand</li>
                                        </ul>
                                    </p>
                                </div>
                            } />
                        </TableCell>
                        <TableCell>
                            <span>0</span>
                            <Button appearance="transparent" size="small" style={{ marginLeft: "0.5rem" }} icon={<EditIcon />} onClick={() => changeValueOpen("Dexterity", 20)} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <InfoLabel label="Constitution" info={
                                <div>
                                    <b>Constitution</b>
                                    <p>
                                        Endurance and toughness.
                                    </p>
                                    <p>
                                        <b>Used for:</b>
                                        <ul>
                                            <li>Hit points (your health pool)</li>
                                            <li>Resisting poison, disease, fatigue</li>
                                            <li>Concentration checks (for spells)</li>
                                        </ul>
                                    </p>
                                </div>
                            } />
                        </TableCell>
                        <TableCell>
                            <span>0</span>
                            <Button appearance="transparent" size="small" style={{ marginLeft: "0.5rem" }} icon={<EditIcon />} onClick={() => changeValueOpen("Constitution", 20)} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <InfoLabel label="Intelligence" info={
                                <div>
                                    <b>Intelligence</b>
                                    <p>
                                        Reasoning, memory, knowledge.
                                    </p>
                                    <p>
                                        <b>Used for:</b>
                                        <ul>
                                            <li>Arcana, history, investigation, nature, religion</li>
                                            <li>Science experiments</li>
                                            <li>Matrix research, computer and technology hacking</li>
                                        </ul>
                                    </p>
                                </div>
                            } />
                        </TableCell>
                        <TableCell>
                            <span>0</span>
                            <Button appearance="transparent" size="small" style={{ marginLeft: "0.5rem" }} icon={<EditIcon />} onClick={() => changeValueOpen("Intelligence", 20)} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <InfoLabel label="Wisdom" info={
                                <div>
                                    <b>Wisdom</b>
                                    <p>
                                        Awareness, perception, intuition.
                                    </p>
                                    <p>
                                        <b>Used for:</b>
                                        <ul>
                                            <li>Perception (spotting danger)</li>
                                            <li>Insight (reading people)</li>
                                            <li>Survival, medicine</li>
                                        </ul>
                                    </p>
                                </div>
                            } />
                        </TableCell>
                        <TableCell>
                            <span>0</span>
                            <Button appearance="transparent" size="small" style={{ marginLeft: "0.5rem" }} icon={<EditIcon />} onClick={() => changeValueOpen("Wisdom", 20)} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <InfoLabel label="Charisma" info={
                                <div>
                                    <b>Charisma</b>
                                    <p>
                                        Force of personality, charm, presence.
                                    </p>
                                    <p>
                                        <b>Used for:</b>
                                        <ul>
                                            <li>Persuasion, deception, intimidation, performance</li>
                                        </ul>
                                    </p>
                                </div>
                            } />
                        </TableCell>
                        <TableCell>
                            <span>0</span>
                            <Button appearance="transparent" size="small" style={{ marginLeft: "0.5rem" }} icon={<EditIcon />} onClick={() => changeValueOpen("Charisma", 20)} />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>

            <ChangeValueDialog valueName={changeValueName} valueMax={changeValueMax} open={changeValueDialogOpen} setOpen={setChangeValueDialogOpen} callback={handleChangeValue} />
        </div>
    );
}